module.exports = __webpack_public_path__ + "static/mfg-about_empire-2-min.b6503185.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/about/mfg-about_empire-2-min.png
// module id = 662
// module chunks = 49508567561676